<!-- 表单填写框 -->
<template>
    <div class="form_wrapper">
        <div class="left_form">
            <div class="title">请顾问来电介绍</div>
            <div class="description">留下联系方式，广告顾问将联系您提供免费咨询</div>
            <el-form ref="form" 
                :rules="rules" 
                :model="cueForm">
                <el-form-item prop="name">
                    <el-input 
                        class="input_bg"
                        placeholder='姓名（必填）'
                        v-model="cueForm.name"></el-input>
                </el-form-item>
                <el-form-item prop="tel">
                    <el-input 
                        class="input_bg"
                        placeholder='手机（必填）'
                        v-model="cueForm.tel"></el-input>
                </el-form-item>
                <el-form-item prop="mail">
                    <el-input 
                        class="input_bg"
                        placeholder='邮箱'
                        v-model="cueForm.mail"></el-input>
                </el-form-item>
                <el-form-item prop="refer">
                    <el-input 
                        class="input_bg"
                        placeholder='推广网站/App名称'
                        v-model="cueForm.refer"></el-input>
                </el-form-item>
                <el-form-item 
                    class="submit"
                    size="large">
                    <el-button
                        style="width:120px" 
                        class='btn_active'
                        type="primary" 
                        @click="bind_push_form">立即提交</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="right_form">
            <div class="title">新客户专线</div>
            <div class="description">致电推广顾问，获得免费咨询</div>
            <div class="call">
                <div class="call_wrapper">
                    <div class="call_icon"><i class="el-icon-phone"></i></div>
                    <div class="call_num">400-6789-163</div>
                </div>
            </div>
            <div class="mail">邮箱：service@corp.youdao.com</div>
            <div class="time">客服电话工作时间</div>
            <div class="time_num">工作日9:30-18:00</div>
        </div>
    </div>
</template>
<script>
    import CONSTANT from '@/util/constant';
    export default {
        data() {
            var validateTel = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机号码'));
                } else if (!(/^1[34578]\d{9}$/.test(value))){
                    callback(new Error('请输入正确的手机号码'));
                } else {
                    callback();
                }
            };
            return {
                cueForm: {
                
                },
                // 表单规则
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    tel: [
                        { validator: validateTel, trigger: 'blur' }
                    ],
                }
            };
        },
        mounted() {
            if (!('placeholder' in document.createElement('input'))) {
                this.cueForm = {
                    name: '姓名（必填）',
                    tel: '手机（必填）',
                    mail: '邮箱',
                    refer: '推广网站/APP名称'
                }
            } 
        },
        methods: {
            // 提交表单
            bind_push_form() {
                // 百度统计
                window._hmt.push(['_trackEvent', 'formSubmit', `${this.$route.path.slice(1)}`]);
                this.$refs.form.validate((valid) => {
                    // 验证成功,提交表单
                    if (valid) {
                        let vals = [
                            `name=${encodeURIComponent(this.cueForm.name)}`,
                            `phone=${encodeURIComponent(this.cueForm.tel)}`,
                            `qq=${encodeURIComponent(this.cueForm.qq)}`,
                            `reffer=${encodeURIComponent(this.cueForm.refer)}`
                        ]
                        let turl = `${CONSTANT.FORM_URL}&${vals.join('&')}`;
                        (new Image()).src = turl;
                        setTimeout(() => {
                            this.$message({
                                message: '提交成功',
                                center: true,
                                type: 'success',
                                customClass: 'msg_center',
                                duration: 1000
                            })
                        }, 500)
                    } else {
                        return false
                    }
                })
            }
        }
    }
</script>
<style>
    .form_wrapper {
        width: 1280px;
        height: 600px;
        background: #FFFFFF;
        box-shadow: 0 2px 30px 0 rgba(204,230,255,0.36);
        border-radius: 12px;
        text-align: center;
    }
    /* 左右半边标题和描述的样式 */
    .form_wrapper .title {
        font-family: "HYQiHei-GZS";
        font-size: 32px;
        color: #242933;
        letter-spacing: 0;
        line-height: 32px;
        margin-bottom: 16px;
    }
    .form_wrapper .description {
        font-family: "PingFangSC-Regular";
        font-size: 14px;
        color: #A9AEB8;
        letter-spacing: 0;
        text-align: center;
        line-height: 14px;
        margin-bottom: 64px;
    }
    /* 左半边表单样式 */
    .left_form {
        float: left;
        width: 480px;
        margin-left: 180px;
        margin-top: 80px;
    }
    .left_form .input_bg input{
        background: #F7F9FC;
    }
    .left_form .submit {
        text-align: left;
    }
    /* 右半边表单样式 */
    .right_form {
        margin-top: 80px;
        width: 440px;
        float: right;
    }
    .right_form .call{
        border-left: 1px solid #F2F4F7;
        height: 236px;
        position: relative;
    }
    .call .call_wrapper {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -127.5px;
        margin-top: -49px;
    }
    .call .call_icon {
        font-size: 20px;
        margin-bottom: 31px;
    }
    .call .call_num {
        width: 255px;
        /* font-family: HelveticaNeue-Light; */
        font-size: 36px;
        color: #FF824C;
        letter-spacing: 0;
        text-align: center;
        line-height: 44px;
    }
    .right_form .time, .right_form .mail {
        margin-top: 24px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #C0C6D1;
        letter-spacing: 0;
        text-align: center;
        line-height: 14px;
    }
    .right_form .time_num {
        margin-top: 24px;
        opacity: 0.8;
        font-family: "PingFangSC-Regular";
        font-size: 16px;
        color: #636770;
        letter-spacing: 0;
        text-align: center;
        line-height: 18px;
    }
</style>




// WEBPACK FOOTER //
// src/components/CmsForm.vue